module.exports = __WEBPACK_EXTERNAL_MODULE_87__;


//////////////////
// WEBPACK FOOTER
// external "element-ui/lib/utils/popup/popup-manager"
// module id = 87
// module chunks = 0 1